import { message } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import DriverLicenseImage from 'assets/images/driver-portal/preview/driving-license.png';
import { Button, FormItem, Select } from 'components';
import { theme } from 'configs/styled';
import Divider from 'containers/DriverPortalPage/components/Divider';
import DriverPortalLayout from 'containers/DriverPortalPage/components/DriverPortalLayout';
import Title from 'containers/DriverPortalPage/components/Title';
import { FormikProps, FormikValues, useFormik } from 'formik';
import usePrompt from 'hooks/usePrompt';
import { useQueryParams } from 'hooks/useQueryParams';
import { useUpdateExpireDateImages } from 'hooks/useUpdateExpireDateImages';
import React, { useCallback, useEffect, useState } from 'react';
import {
  addressService,
  authenticationService,
  documentReaderService,
  mainService,
  uploadService,
} from 'services/driverPortal';
import { STATUS_RESPONSE } from 'services/driverPortal/DriverPortal.interface';
import { appendOcrMetadata } from 'utils/appendOcrMetadata';
import * as Yup from 'yup';
import Loading from '../../../../components/ReturnOrderModal/Loading';
import { ReaderType } from '../../../../services/driverPortal/documentReader/DocumentReaderService';
import { isPdfFile } from '../../../../utils/isFilePdf';
import { toIsoDate } from '../../../../utils/validate';
import { ISelectAddressProps } from '../../MainPage/PersonalInformationPage';
import ConfirmReturnModal from '../components/ConfirmReturnModal';
import HeaderPortal from '../components/HeaderPortal';
import Information from '../components/Information';
import ReturnButton from '../components/ReturnButton';
import UploadImageForm from '../components/UploadImageForm';

interface IDriverLicenseImage {
  image: string;
  createdAt?: string;
}

interface IDriverLicenseRequest {
  type?: string;
  document: IDriverLicenseImage;
  status?: string;
  fileData?: any;
  error?: IError;
}

interface IError {
  driverLicenseError?: string;
}

interface IDriverLicenseImageUpload {
  document?: FormData;
}

interface IDriverLicenseRequest {
  drivingLicense?: string | File;
  drivingLicenseDocument?: { image?: string };

  drivingLicenseType?: number;
  drivingLicenseNo?: string | number;
  issueDate?: string;
  expireDate?: string;
  fullnameTh?: string;
  fullnameEn?: string;
  birthDate?: string;
  registrarTh?: string;
  registrarEn?: string;

  // fileData?: {
  //   birth_date_en?: string;
  //   full_name_th?: string;
  //   full_name_en?: string;
  //   issue_date?: string;
  //   expiry_date?: string;
  //   registrar_th?: string | null;
  //   registrar_en?: string | null;
  //   driving_license_type?: string | number | null;
  //   driving_license_number_th?: string | null;
  //   driving_license_number_en?: string | null;
  // };
}

enum ImageTypes {
  DOCUMENT = 'document',
}

const imageKeys: ImageTypes[] = [ImageTypes.DOCUMENT];

const folderType = 'driver-license';

const validateDriverLicense = Yup.object().shape({
  type: Yup.string().nullable().required('กรุณาเลือกประเภทใบขับขี่'),
  document: Yup.object().shape({
    image: Yup.string().nullable().required('กรุณาเลือกรูปภาพ'),
  }),
});

export interface IDriverLicensePageProps {}

const DriverLicensePage: React.FC<IDriverLicensePageProps> = () => {
  const { userId, accessToken } = authenticationService.getUserToken();
  const [isShowModal, setIsShowModal] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [imageDeletionFiles, setImageDeletionFiles] = useState<UploadFile[]>(
    [],
  );
  const [licenseType, setLicenseType] = useState<ISelectAddressProps[]>([]);
  const { updateByFiles } = useUpdateExpireDateImages();
  const { search, pushUrl } = useQueryParams();
  const [, setShowPrompt] = usePrompt();
  const [formDirty, setFormDirty] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState<IDriverLicenseImageUpload>(
    {},
  );
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [fileDriverLicense, setFileDriverLicense] = useState<string>('');

  useEffect(() => {
    const { accessToken } = authenticationService.getUserToken() || {};
    if (!accessToken) {
      pushUrl('/login', search);
    }
  }, [pushUrl, search]);

  const buildPayloadDrivingLicense = async (
    values: IDriverLicenseRequest,
  ): Promise<FormData> => {
    const f = values.fileData ?? {};

    const drivingLicenseNo =
      values.drivingLicenseNo ??
      f.driving_license_number_th ??
      f.driving_license_number_en ??
      '';

    // const driverLicense: number =
    //   licenseType.find(r => r.label === values.type)?.id ?? 0;

    const driverLicense = licenseType.find(f => f._id === values.type)?._id;

    console.log('=========driverLicense', driverLicense);

    const fd = new FormData();
    fd.append('tab', 'driving_license');

    fd.append('drivingLicenseType', String(values.type ?? ''));
    fd.append(
      'drivingLicenseNo',
      String(drivingLicenseNo?.replace('ฉบับที่ ', '')),
    );
    fd.append('issueDate', toIsoDate(values.issueDate ?? f.issue_date));
    fd.append('expireDate', toIsoDate(values.expireDate ?? f.expiry_date));

    fd.append('fullnameTh', values.fullnameTh ?? f.full_name_th ?? '');
    fd.append('fullnameEn', values.fullnameEn ?? f.full_name_en ?? '');
    fd.append('birthDate', toIsoDate(values.birthDate ?? f.birth_date_en));

    fd.append('registrarTh', values.registrarTh ?? f.registrar_th ?? '');
    fd.append('registrarEn', values.registrarEn ?? f.registrar_en ?? '');
    appendOcrMetadata(fd, 'drivingLicenseOcrMetadata', f);

    if (filesToUpload.document) {
      fd.append('drivingLicense', filesToUpload.document.get('files') as Blob);
    }

    return fd;
  };

  const goToMainPage = () => {
    pushUrl('/', search);
  };

  const goToLoginPage = () => {
    pushUrl('/login', search);
  };

  const uploadImage = async (
    files: IDriverLicenseImageUpload,
    key: ImageTypes,
    formValues: IDriverLicenseRequest,
    createdAt: string,
  ) => {
    const uploadFile = files[key] || null;

    if (uploadFile) {
      const response = await uploadService.uploadFile(uploadFile);

      if (response.data) {
        formValues[key] = {
          image: response.data[0],
          createdAt,
        };
      }
    }
  };

  const formik = useFormik<IDriverLicenseRequest>({
    initialValues: {
      error: {
        driverLicenseError: undefined,
      },
      type: undefined,
      document: {
        image: '',
        createdAt: '',
      },
      fileData: null,
    },
    validationSchema: validateDriverLicense,
    enableReinitialize: true,

    onSubmit: async (formValues, action) => {
      if (saveLoading) return;
      setSaveLoading(true);
      try {
        setShowPrompt(false);

        const payload = await buildPayloadDrivingLicense(formValues);
        console.log('============payload', payload);

        if (payload instanceof FormData) {
          for (const [k, v] of payload.entries()) {
            console.log(
              k,
              v instanceof File ? `${v.name} (${v.type}, ${v.size}b)` : v,
            );
          }
        } else {
          console.log('payload', payload);
        }

        const res = await addressService.updateInfo(payload);
        console.log('=========success', res);

        const out = (res as any)?.data ?? res;

        if (out?.success === false) {
          const msg =
            out?.errorMessageList?.[0] || out?.message || 'บันทึกไม่สำเร็จ';
          message.error(msg);
          return;
        }

        message.success(out?.message || 'บันทึกข้อมูลเรียบร้อยแล้ว');
        goToMainPage();
      } catch (err) {
        const status = err?.response?.status ?? err?.status;
        if (status === STATUS_RESPONSE.UNAUTHORIZED) {
          await authenticationService.logout();
          goToLoginPage();
          return;
        }
        const apiMsg =
          err?.response?.data?.message ||
          err?.message ||
          'เกิดข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้';
        message.error(apiMsg);
        console.error('[update-info] error:', err);
      } finally {
        action?.setSubmitting?.(false);
        setSaveLoading(false);
      }
    },
  });

  const mapDrivingLicenseType = (ocrType?: string) => {
    const text = (ocrType || '').toLowerCase().trim();

    if (!text) return undefined;

    if (text.includes('lifetime private motorcycle driving license'))
      return '2';
    if (text.includes('private motorcycle driving license')) return '1';
    if (text.includes('public motorcycle driving license')) return '3';

    return undefined;
  };

  const readerFile = async (file: File) => {
    try {
      if (file) {
        const response = await documentReaderService.readerFile(
          file,
          ReaderType.DRIVING_LICENSE,
        );

        console.log('==========payload', response);

        if (response.status) {
          setDisableSubmit(false);
          formik.setFieldValue('fileData', response);
          formik.setFieldValue('error', {
            driverLicenseError: undefined,
          });

          const mappedType = mapDrivingLicenseType(
            response?.driving_license_type,
          );

          if (mappedType) {
            formik.setFieldValue('type', mappedType);
          }
        } else {
          setDisableSubmit(true);
          formik.setFieldValue('fileData', {});
          formik.setFieldValue('error', {
            driverLicenseError: 'ระบบไม่สามารถอัพโหลดรูปที่ไม่ใช่ใบขับขี่ได้',
          });
        }
      }
    } catch (e) {
      console.log('===== Debug error status: ', e.toString());
    }
  };

  const loadImage = async (path: string) => {
    try {
      const response = await mainService.loadImageAxios(path);
      return response;
    } catch (e) {
      return null;
    }
  };

  const getInfo = async () => {
    try {
      const response = await mainService.getInfo();
      // const response = mainService.getMockPotentialLead(id);

      if (response.data.potentialLeadDrivingLicense) {
        const licenseData = response.data.potentialLeadDrivingLicense;

        setIsApproved(licenseData.statusCode === 'approved');

        const findData = licenseType?.find(
          f => f._id == licenseData.drivingLicenseType?.toString(),
        );

        console.log(response.data, findData);
        formik.setFieldValue(
          'type',
          findData?.value ?? findData?._id ?? undefined,
        );

        if (licenseData?.drivingLicense) {
          const image = await loadImage(licenseData?.drivingLicense);
          setFileDriverLicense(licenseData?.drivingLicense);
          formik.setFieldValue('fileData', {});
          formik.setFieldValue('document', {
            image: image ? image.url : undefined,
          });
        }
      }
    } catch (e) {
      console.log('===== Debug error status: ', e.toString());
    }
  };

  useEffect(() => {
    const { dirty, isSubmitting } = formik;
    const isDirty = !isSubmitting && dirty;
    setFormDirty(isDirty);

    setIsShowModal(isDirty);

    setShowPrompt(isDirty);
  }, [formik]);

  const handleSelect = (key: string, value: string) => {
    formik.setFieldValue(key, value);
  };

  const errors = formik.errors || {};

  const handleUnauthorized = useCallback(async status => {
    if (status === STATUS_RESPONSE.UNAUTHORIZED) {
      await authenticationService.logout();
      goToMainPage();
    }
  }, []);

  const handleRemoveImage = useCallback(
    (file: UploadFile) => {
      formik.setFieldValue('fileData', undefined);

      setDisableSubmit(false);
      formik.setFieldValue('error', {
        driverLicenseError: undefined,
      });

      if (!file.fileName?.match(/^blob\:/)) {
        setImageDeletionFiles([...imageDeletionFiles, file]);
      }
    },
    [imageDeletionFiles],
  );

  const getLicenseTypeMaster = async () => {
    try {
      return await addressService.getLicenseTypeMaster();
    } catch (err) {}
  };

  useEffect(() => {
    if (licenseType.length > 0) {
      getInfo();
    }
  }, [licenseType]);

  useEffect(() => {
    const getLicenseType = async () => {
      const licenseType = await getLicenseTypeMaster();
      if (!licenseType) return;

      const _licenseType = licenseType.dataList.map(item => ({
        _id: item.id.toString(),
        value: item.id.toString(),
        label: item.name,
        title: item.name,
      }));

      setLicenseType(_licenseType);
    };

    getLicenseType();
  }, []);

  const shouldDisplayButton = () => {
    return (
      disableEdit ||
      disableSubmit ||
      !formik.values.type ||
      !formik.values.document.image
    );
  };

  const shouldDisplayErrorMessage = (key: keyof IDriverLicenseRequest) => {
    return formik.touched[key] && formik.errors[key];
  };

  return (
    <>
      {formik.values.document.image && !formik.values.fileData && <Loading />}

      <form onSubmit={formik.handleSubmit}>
        <HeaderPortal
          // documentsReviewStatusName={
          //   driverLicense?.data?.documentsReviewStatus?.status
          // }
          formik={formik as FormikProps<FormikValues>}
        />
        <DriverPortalLayout>
          <ReturnButton />
          <Information
            title="ใบขับขี่"
            description='กรุณากรอกข้อมูล และอัพโหลดเอกสารที่มีเครื่องหมาย * ให้ครบถ้วน แล้วกด "บันทึก"'
          />

          <Divider />

          <div style={{ marginBottom: theme.spacing.xl }}>
            <Title fontSize={theme.fontSize.md}>ข้อมูลใบขับขี่</Title>

            <FormItem
              label="ประเภทใบขับขี่"
              required
              labelCol={{ span: 24 }}
              validateStatus={shouldDisplayErrorMessage('type') ? 'error' : ''}
              help={shouldDisplayErrorMessage('type') && errors.type}
            >
              <Select
                disabled={disableEdit || isApproved}
                size="large"
                showSearch
                placeholder="เลือกประเภทใบขับขี่"
                options={licenseType}
                optionLabelProp="title"
                value={formik?.values?.type}
                onBlur={() => formik.setFieldTouched('type', true)}
                onChange={value => {
                  console.log('===== type', value);
                  formik.setFieldValue('type', value);
                }}
                onDropdownVisibleChange={open => {
                  if (!open) formik.setFieldTouched('type', true);
                }}
              />
            </FormItem>
          </div>

          <Divider />

          <FormItem
            required
            labelCol={{ span: 24 }}
            colon={false}
            validateStatus={
              errors?.document?.image || formik.values.error?.driverLicenseError
                ? 'error'
                : ''
            }
            help={
              formik.values.error?.driverLicenseError ?? errors?.document?.image
            }
          >
            <UploadImageForm
              disabled={disableEdit || isApproved}
              title="อัพโหลดรูปใบขับขี่ (ด้านหน้า)"
              required
              bulletList={[
                'โปรดอัพโหลดใบขับขี่สาธารณะ ถ้ามี',
                'กรณีไม่มีใบขับขี่สาธารณะ สามารถอัพโหลดใบขับขี่ส่วนบุคคลได้',
                'ข้อมูลในใบขับขี่ต้องตรงกับบัตรประจำตัวประชาชน',
                'ใบขับขี่อยู่ในสภาพสมบูรณ์และไม่หมดอายุ',
                'ไม่แก้ไขและตกแต่งรูป',
                'เห็นข้อมูลชัดเจนและครบถ้วน',
              ]}
              previewTitle="ตัวอย่างรูปใบขับขี่"
              previewUrl={DriverLicenseImage}
              onChange={value => {
                const files = value.uploadFileForm
                  ? (value.uploadFileForm.get('files') as Blob)
                  : '';

                setFilesToUpload({
                  ...filesToUpload,
                  document: value.uploadFileForm,
                });

                formik.setFieldValue('document', {
                  image: files ? URL.createObjectURL(files) : '',
                });

                if (value.uploadFileForm?.get('files')) {
                  // @ts-ignore
                  readerFile(value.uploadFileForm.get('files'));
                }
              }}
              onRemove={handleRemoveImage}
              nameImage="รูปใบขับขี่"
              pathImage={formik.values.document.image}
              folder={folderType}
              isPdf={isPdfFile(fileDriverLicense)}
              fileName={fileDriverLicense}
            />
          </FormItem>

          <Divider />

          <Button
            disabled={shouldDisplayButton() || isApproved}
            block
            size="large"
            type={shouldDisplayButton() || isApproved ? 'default' : 'primary'}
            htmlType="submit"
            loading={saveLoading}
          >
            บันทึก
          </Button>
        </DriverPortalLayout>
        {formDirty && <ConfirmReturnModal isShow={isShowModal} />}
      </form>
    </>
  );
};

export default DriverLicensePage;
